import { assert } from '../app/logger.js';

/**
 * Animates UI while data is loading.
 */
class UILoader {
  /**
   * Sets 'loading' class name on an element after the given timeout until
   * the given promise is resolved. When the promise is resolved, then
   * 'loading' class name is cleared. If multiple requests are made for
   * the same element before the 'loading' class name is cleared, then
   * the class will be cleared after the last promise is resolved.
   */
  animate(el, promise, timeout = UILoader.DefaultTimeout) {
    assert(el, `[ui] no element to animate`);
    let data = this.#els.get(el);
    if (!data) {
      data = {
        promises: [],
        timeoutId: 0,
      };
      this.#els.set(el, data);
    }

    let size = data.promises.push(promise);
    let donePromise = Promise.allSettled(data.promises).then(() =>
      this.stop(el, size)
    );
    if (size == 1) {
      if (timeout == UILoader.NoTimeout) {
        this.setLoadingOn(el);
        return;
      }
      data.timeoutId = setTimeout(() => this.setLoadingOn(el), timeout);
    }
    return donePromise;
  }

  stop(el, size) {
    let data = this.#els.get(el);
    if (data.promises.length == size) {
      if (data.timeoutId) {
        clearTimeout(data.timeoutId);
      }
      this.setLoadingOff(el);
      this.#els.delete(el);
    }
  }

  setLoadingOn(el) {
    el.classList.add('loading');
  }

  setLoadingOff(el) {
    el.classList.remove('loading');
  }

  static get DefaultTimeout() {
    return 300;
  }
  static get NoTimeout() {
    return -1;
  }

  #els = new Map();
}

const uiLoader = new UILoader();
const animateUILoading = (...args) => uiLoader.animate(...args);

export { UILoader, animateUILoading };
